import { css } from "@emotion/css";
import { Tooltip } from "@octopusdeploy/design-system-components";
import { ExclamationTriangleIcon } from "@octopusdeploy/design-system-icons";
import { space, themeTokens } from "@octopusdeploy/design-system-tokens";
import type { ReactNode } from "react";
import type React from "react";
import styles from "./ProcessActionErrorIndicator.module.less";
interface ProcessActionWarningIndicatorProps {
    actionWarnings: (string | ReactNode)[];
    accessibleName?: string;
}
const iconStyles = css({
    marginRight: space[8],
    paddingBottom: space[1], // visually align the warning icon
});
const containerStyles = css({
    alignSelf: "center",
    display: "flex",
});
export const ProcessActionWarningIndicator: React.FC<ProcessActionWarningIndicatorProps> = ({ actionWarnings, accessibleName }) => {
    const items = actionWarnings.map((x, index) => <li key={index}>{x}</li>);
    return (<div className={containerStyles}>
            <Tooltip content={<ul className={styles.itemContainer}>{items}</ul>}>
                <div className={iconStyles} role="img" aria-label={accessibleName}>
                    <ExclamationTriangleIcon size={24} color={themeTokens.color.icon.warning}/>
                </div>
            </Tooltip>
        </div>);
};
ProcessActionWarningIndicator.displayName = "ProcessActionWarningIndicator"
